// extracted by mini-css-extract-plugin
module.exports = {"tag":"encrypt_tag__2X4yr"};